import {Component, Input, OnInit} from "@angular/core";
import {ServerService} from "../../shared/services/server.service";
import {FlatsInfo, ISpot, RoomTypeEnum} from "../../shared/models/models";
import {CommonModule} from "@angular/common";
import {NumberWithSpacesPipe} from "../../shared/pipes/number-with-spaces.pipe";
import {FlatsComponent} from "./flats/flats.component";
import { CommercialRoomsComponent, IPlace } from "../spot-form-editor/commercial-rooms/commercial-rooms.component";
import { MatDialog } from "@angular/material/dialog";
import { SaleDialogComponent } from "../../new-realization/dialogs/sale-dialog/sale-dialog.component";

@Component({
  selector: "app-toogle-obj",
  templateUrl: "./toogle-obj.component.html",
  styleUrls: ["./toogle-obj.component.scss"],
  standalone: true,
  imports: [CommonModule, FlatsComponent, NumberWithSpacesPipe, CommercialRoomsComponent]
})
export class ToogleObjComponent implements OnInit {

  @Input() spotId: number;
  @Input() spotObject: ISpot;

  loadingFlatsInfo: boolean = false;
  itemsForFlats: FlatsInfo[];
  firstFlat: FlatsInfo;

  itemsForFlatsEx: FlatsInfo[];
  reloadTrigger: number = 0;
  protected readonly RoomTypeEnum = RoomTypeEnum;


  constructor(private server: ServerService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.loadingFlatsInfo = true;
    this.server.getRealizationFlatSalesInfo(this.spotId).then(rest => {
      if (rest) {
        this.loadingFlatsInfo = false;
        this.itemsForFlats = rest.slice(1, rest.length);
        this.itemsForFlatsEx = this.itemsForFlats;//.filter(r => r.totalFlatCount > 0);
        // console.log(this.itemsForFlatsEx, '-----');
        this.firstFlat = rest[0];
      }
    });
  }

  reloadData(event) {
    if (event) {
      this.loadData();
    }
  }

  openSaleDialog({place, floorId}, roomTypeID: RoomTypeEnum) {
    this.dialog.open(SaleDialogComponent, {
      width: '900px',
      minWidth: '900px',
      height: '600px',
      autoFocus: false,
      disableClose: true,
      data: {
        roomTypeID: roomTypeID,
        place,
        floorId,
        buildingId: this.spotId,
      }
    }).afterClosed().subscribe(result => {
      if (result) {
        this.reloadTrigger++;
        this.reloadData(true);
      }
    });
  }

}
